import React from 'react';
import SiteFooter from '../components/SiteFooter';

export default function RefundPolicyPage() {
  const paragraphs = [
  "Редакція від 13.02.2026",
  "1. Загальні положення",
  "1.1. Повернення здійснюється відповідно до Закону України «Про захист прав споживачів».",
  "1.2. Монети є внутрішньою обліковою одиницею та не є товаром або грошовим зобов’язанням.",
  "2. Умови повернення",
  "2.1. Повернення можливе протягом 14 календарних днів з дати оплати, якщо монети не використані.",
  "2.2. Запит надсилається на: knyhoobih@gmail.com із зазначенням email, суми та ID транзакції.",
  "3. Строки",
  "3.1. Розгляд запиту — до 5 робочих днів.",
  "3.2. Повернення коштів — до 7 банківських днів тим самим способом оплати.",
  "4. Обмеження",
  "Після використання монет послуга вважається наданою належним чином."
  ];

  return (
    <div style={{ background: '#F6F4EF', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <main style={{ maxWidth: 900, margin: '0 auto', padding: '24px 16px', width: '100%', flex: 1 }}>
        <section
          style={{
            background: '#fff',
            border: '1px solid #e5e7eb',
            borderRadius: 14,
            padding: '20px 16px',
          }}
        >
          <h1 style={{ margin: '0 0 8px', color: '#0b5226' }}>ПОЛІТИКА ПОВЕРНЕННЯ КОШТІВ «КНИГООБІГ»</h1>
          {paragraphs.map((text, idx) => (
            <p
              key={idx}
              style={{
                margin: idx === paragraphs.length - 1 ? 0 : '0 0 10px',
                color: '#374151',
                lineHeight: 1.6,
              }}
            >
              {text}
            </p>
          ))}
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}
